import {api} from '_api';
import type {Finder, Mutator} from '_types/swr';

import {unwrap} from '_utils/axios';
import {parseKey} from '_utils/swr';
import {GeneratedDeskUserToken} from '_types/responses/generated-desk-user-token';
import type {Role} from "_types/models/Role";
import type {RoleStore} from "_types/requests/role";

export const generateToken: Mutator<GeneratedDeskUserToken, {}> = async (queryKey) => {
    const url = parseKey(queryKey);
    const response = await api.post<GeneratedDeskUserToken>(url);

    return await unwrap(response);
};
